module.exports = __webpack_public_path__ + "img/13.1dcac260.png";